import { IArbetsorderDetail } from "~app/features/planera/model/IArbetsorderDetail";
import { IAtgard } from "~app/features/planera/model/IAtgard";

export interface IAnteckningMap {
    [key: string]: IAtgard[];
}

export interface IAnteckning {
    typ: string;
    anteckning: string;
    atgarder: IAtgard[];
}

export class ArbetsorderInfoAnteckningSelection {
    arbetsorder: IArbetsorderDetail;
    atgard: IAtgard;
    arbetsorderAnteckningar: IAnteckning[];

    constructor() {
        this.arbetsorder = undefined;
        this.atgard = undefined;
        this.arbetsorderAnteckningar = undefined;
    }
}
